import React, { memo, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Zip } from 'site-modules/shared/components/zip/zip';
import { UsurpZipInput } from 'site-modules/shared/components/inventory/usurp-zip-input/usurp-zip-input';

import './zip-code-reminder.scss';

export const ZipCodeReminder = memo(
  ({ className = null, onZipCodeUpdate = null, isNational = false, isMobile = false, zipCode = null }) => {
    const [isNationalInitially] = useState(isNational);

    if (!isNationalInitially) return null;

    return (
      <div
        className={classNames(
          'zip-code-reminder-national-zip bg-blue-90 overlay-white-50 right px-1 text-cool-gray-30 mb-1',
          className
        )}
        style={{ position: 'relative', bottom: 0, left: 0, width: 'auto' }}
      >
        <div className="d-flex align-items-center user-zip-input-container" data-tracking-parent="zip-input-message">
          {isMobile ? (
            <UsurpZipInput
              className="me-0_75 mobile-national-zip"
              onZipCodeUpdate={onZipCodeUpdate}
              isNational={isNational}
              isMobile={isMobile}
              dataTrackingParent={''}
              errorTextClasses=""
            />
          ) : (
            <i className="align-self-center pe-0_5 icon-location text-blue-50" aria-hidden />
          )}
          <div className={classNames({ 'size-14': isMobile })}>
            Showing <span className="fw-bold">{isNational ? 'Nationwide' : 'Local'}</span> results.{' '}
            {isNational ? (
              <>
                Enter your{' '}
                {isMobile ? (
                  'ZIP Code'
                ) : (
                  <Zip
                    onUpdate={onZipCodeUpdate}
                    zip={zipCode}
                    buttonText="ZIP Code"
                    buttonClassName="national-zip size-16"
                    showDropdownIcon={false}
                    updateBtnClasses="bg-blue-50"
                  />
                )}{' '}
                for local results.
              </>
            ) : (
              'Filter the results to find the best car for you.'
            )}
          </div>
        </div>
      </div>
    );
  }
);

ZipCodeReminder.displayName = 'ZipCodeReminder';

ZipCodeReminder.propTypes = {
  onZipCodeUpdate: PropTypes.func,
  className: PropTypes.string,
  isNational: PropTypes.bool,
  isMobile: PropTypes.bool,
  zipCode: PropTypes.string,
};
